import { Ajax } from '../classes/ajax';
import { getYMD } from '../utils/get-date';
import { DisableStockCheck, EnableStockCheck } from './app';

export function toggle() {
    return function(dispatch) {
        dispatch({
            type: 'CART/TOGGLE',
        });
    };
}

export function close() {
    return function(dispatch) {
        dispatch({
            type: 'CART/CLOSE',
        });
    };
}

export function open() {
    return function(dispatch) {
        dispatch({
            type: 'CART/OPEN',
        });
    };
}

export function clear(soft) {
    if (soft == null) {
        soft = false;
    }

    return function(dispatch) {
        dispatch({
            type: 'CART/CLEAR',
        });

        const params = {
            security: application.nonce,
            action: 'nch_empty_cart',
        };

        return new Ajax(
            'POST_WORDPRESS',
            NOJESRESOR_WORDPRESS.ajaxurl + '/empty_cart',
            params,
        )
            .then((result) => {
                if (soft) {
                    dispatch({type: 'APP/SOFT_CLEAR'});
                } else {
                    dispatch({type: 'APP/CLEAR'});
                }

                dispatch(clearEmptyCartOverlay());
            })
            .catch((ex) => {
                dispatch({
                    type: 'CART/SEND_TO_WORDPRESS_ERROR',
                });
            });
    };
}

export function clearEmptyCartOverlay() {
    return function(dispatch) {
        dispatch({
            type: 'CART/CLEAR_EMPTY_CART_OVERLAY',
        });
    };
}

export function clearSendToWordPressError() {
    return function(dispatch) {
        dispatch({
            type: 'CART/SEND_TO_WORDPRESS_ERROR_CLEAR',
        });
    };
}

function validateCartBeforeCheckout(params, cart) {
    if (!cart.optional_hotel && !cart.without_hotel && params.hotel == null) {
        params.tickets = null;
        params.hotel = null;
        params.food = null;
        params.dinner = null;
    }

    return params;
}

export function sendToWordPress() {
    return function(dispatch, getState) {
        dispatch({
            type: 'CART/CREATE',
        });

        dispatch(DisableStockCheck());

        return new Ajax(
            'POST_WORDPRESS',
            NOJESRESOR_WORDPRESS.ajaxurl + '/create_session',
            {
                security: application.nonce,
                action: 'nch_create_session',
            },
        ).then(function() {
            console.log('SESSION CREATED');

            const {cart} = getState();

            const tickets = prepareTickets(cart);
            const hotel = prepareHotel(cart);
            const food = cart.confirmed_food;
            const giftcards = cart.giftcards;
            let params = {
                security: application.nonce,
                action: 'nch_add_to_cart',
                event: cart.product ? cart.product.id : null,
                tickets: tickets,
                hotel: hotel,
                food: food,
                giftcards: giftcards,
            };

            if (tickets.length > 0) {
                dispatch({
                    type: 'CART/START_TIMER',
                });
            }

            params = validateCartBeforeCheckout(params, cart);

            return new Ajax(
                'POST_WORDPRESS',
                NOJESRESOR_WORDPRESS.ajaxurl + '/add_to_cart',
                params,
            )
                .then((result) => {
                    dispatch({
                        type: 'CART/CREATED',
                    });

                    if (result.status) {
                        document.location.href =
                            '/kassa' + document.location.search;
                    } else {
                        dispatch({
                            type: 'CART/CREATE_ERROR',
                            payload: {
                                code: result.code,
                                message: result.message,
                            },
                        });

                        dispatch(EnableStockCheck());
                    }
                });
        }).catch((ex) => {
            console.error(ex);

            dispatch({
                type: 'CART/CREATE_ERROR',
                payload: {
                    code: -1,
                    message:
                        'Vi kunde inte skapa din varukorg. Om du vill avsluta din bokning så kan du alltid ringa kundtjänst på 08-500 000 45 eller skicka ett mejl till kontakt@nojesresor.se för hjälp.',
                },
            });

            dispatch(EnableStockCheck());
        });
    };
}

function prepareTickets(state) {
    let confirmed_tickets = state.confirmed_tickets;
    let tickets = [];

    for (let i = 0, l = confirmed_tickets.length; i < l; ++i) {
        let ticket = confirmed_tickets[i];

        if (!tickets[ticket.id]) {
            tickets[ticket.id] = {
                id: ticket.id,
                quantity: 1,
            };
        } else {
            tickets[ticket.id] = {
                ...tickets[ticket.id],
                quantity: tickets[ticket.id].quantity + 1,
            };
        }
    }

    return Object.values(tickets);
}

function prepareHotel(state) {
    let confirmed_hotel = state.confirmed_hotel;
    if (confirmed_hotel === null) {
        return null;
    }

    let confirmed_hotel_range = state.confirmed_hotel_range;
    let confirmed_tickets = state.confirmed_tickets;
    let selected_hotel_roomtype = state.selected_hotel_roomtype; // 3 = trippelrum, 1 = singelrum

    const even = confirmed_tickets.length % 2 === 0;
    if (even) {
        selected_hotel_roomtype = null; // @TODO Might not need to make this null. Keep it as 2.
    }

    return {
        id: confirmed_hotel.id,
        guests: confirmed_tickets.length,
        room_type: selected_hotel_roomtype != null
            ? selected_hotel_roomtype
            : 0,
        from: getYMD(confirmed_hotel_range.from),
        to: getYMD(confirmed_hotel_range.to),
    };
}

function prepareFood(state) {
    let confirmed_food = removeFoodProps(state.confirmed_food);
    let confirmed_tickets = state.confirmed_tickets;
    let food = [];
    if (confirmed_tickets.length !== 0 && confirmed_tickets[0].food) {
        food.push({
            id: confirmed_tickets[0].food,
            event_id: confirmed_tickets[0].id,
            quantity: confirmed_tickets.length,
            custom: confirmed_food,
        });
    }

    return food;
}

function removeFoodProps(confirmed_dinner_or_food) {
    if (!confirmed_dinner_or_food) {
        return confirmed_dinner_or_food;
    }
    return {
        meat: confirmed_dinner_or_food.meat.val,
        fish: confirmed_dinner_or_food.fish.val,
        veg: confirmed_dinner_or_food.veg.val,
    };
}
